<template>
  <div class="fundraising">
    <!-- BIG SLOGAN -->
    <div class="container">
      <p class="crowd-or-rais">
        <router-link to="/crowdfunding" class="crowd-or">CROWDFUNDING</router-link>
        <span class="or">/</span>
        <span class="domore-yellow">FUNDRAISING</span>
      </p>
      <h1 class="big-slogan-blue">{{ $t("project.slogan") }}</h1>
      <h2 class="mb-50">{{ $t("project.chooseCategory") }}</h2>
    </div><!-- .container -->

    <!-- FILTERS -->
    <div class="container filters">
      <search :categories="categories" :type="'fundraising'"></search>
    </div><!-- .container .mb-50 -->

    <!-- FUNDRAISING LISTING -->
    <div class="container">
      <div class="all-categories mb-30">
        <strong>FUNDRAISING:</strong> {{ this.search.category }}
      </div>
      <div class="row">
        <div v-for="(project, index) in projects" :key="project.id">
          <div v-if="showSpecialists(index)">
            <specialist-tile v-for="specialist in specialistsRow(index)" :key="specialist.id" :specialist="specialist" size="col-md-4"></specialist-tile>
          </div>
          <fundraising-tile :project="project" size="col-md-4"></fundraising-tile>
        </div>
      </div><!-- .row -->
      <button v-if="!isLast" :disabled="show_loader" type="button" @click="showMore()" class="btn btn-lg button-more-rais">
        <span v-if="!show_loader">  {{ $t("showMore") }} </span>
        <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
      </button>
    </div><!-- .container -->

    <!-- FUNDRAISING ALL CATEGORIES -->
    <div class="container mb-50">
      <div class="all-categories">
        <strong>FUNDRAISING:</strong> {{ $t("project.allCategories") }}
      </div>
      <div class="all-categories-list-rais">
        <ul class="list-inline">
          <li v-for="category in categories">
            <router-link :to="{ name: 'fundraising', query: { category_id: category.id, category: category.name } }">{{ category.name }}</router-link>
          </li>
        </ul>
      </div><!-- .all-categories-list-rais -->
    </div><!-- .container .mb-30 -->

    <crowd-or-rais></crowd-or-rais>
  </div>
</template>

<script>
// API
import userApi from '@/api/v1/user';
import projectsApi from '@/api/v1/projects';
// Components
import FundraisingTile from '@/components/Project/Tiles/Fundraising';
import SpecialistTile from '@/components/Profile/Tiles/Specialist';
import CrowdOrRais from '@/components/CrowdOrRais';
import Search from '@/components/Project/Search';
import ClipLoader from 'vue-spinner/src/ClipLoader';

function showSpecialists(index) {
  return index % 6 === 0 && index !== 0;
}

let lastProfileIndex = 0;
function specialistsRow() {
  const start = lastProfileIndex;
  const end = start + 3;
  const result = this.specialists.slice(start, end);
  lastProfileIndex = end + 1;
  return result.length === 3 ? result : [];
}

export default {
  components: { FundraisingTile, SpecialistTile, CrowdOrRais, Search, ClipLoader },
  data() {
    return {
      projects: [],
      specialists: [],
      tileSize: 'col-md-4',
      categories: [],
      page: 1,
      show_loader: false,
      isLast: true,
    };
  },
  methods: {
    getProjects() {
      projectsApi.search(this.search, (response) => {
        this.show_loader = false;
        this.projects.push(...response.projects);
        this.isLast = response.is_last;
      }, this.page);
    },
    showMore() {
      this.show_loader = true;
      this.page += this.page;
      this.getProjects();
    },
    showSpecialists,
    specialistsRow,
  },
  computed: {
    search() {
      return {
        category_id: this.$route.query.category_id || '',
        category: this.$route.query.category,
        country_id: this.$route.query.country_id || '',
        title: this.$route.query.title,
        city: this.$route.query.city,
      };
    },
  },
  created() {
    lastProfileIndex = 0;
    projectsApi.getCategories((categories) => { this.categories = categories; }, false);
    userApi.getAllUsers((users) => { this.specialists = users; });
    this.search.crowdfunding = false;
    this.getProjects();
  },
  watch: {
    $route() {
      lastProfileIndex = 0;
      this.search.crowdfunding = false;
      // Clear projects
      this.projects = [];
      this.page = 1;
      this.isLast = true;
      this.getProjects();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?f56dd8ae